import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './services/spinner.service';
import { SpinnerState } from './constantes/spinner-state.enum';
import { CybermetrieService } from '@oel/js-cybermetrie';
import { LangueService } from './services/langue/langue.service';
import { TranslateService } from '@ngx-translate/core';
import { GabaritService } from './services/gabarit/gabarit.service';
import { ConfigMeta } from './models/meta';
import { ConfigurationService } from './services/configuration/configuration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  isLoading: boolean;
  isApp: boolean;
  readonly configNavigation: string;

  constructor(
    private readonly spinnerService: SpinnerService,
    private readonly translateService: TranslateService,
    private readonly langueService: LangueService,
    private readonly gabaritService: GabaritService,
    private readonly configurationService: ConfigurationService
  ) {
    CybermetrieService.initialiser();
    this.configNavigation = this.obtenirConfigNavigation();
  }

  private obtenirConfigNavigation() {
    return JSON.stringify({
      typeGabarit: 'transactionnel',
      estModeAuthentifie: true,
      transactionnel: {
        idContenuPrincipal: 'changement-adresse',
        estContexteN3: false,
        aideContactV2: this.obtenirMenuAideEtContact(),
      },
    });
  }

  private obtenirMenuAideEtContact() {
    if (this.configurationService.isConfigEqualValue(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF, 'true')) {
      return { identifiantMenu: 'aidecontact' };
    } else {
      return {
        dataSection: {
          id: 'aidecontact',
          langue: 'fr',
          contexte: 'web',
          items: [{}],
        },
      };
    }
  }

  ngOnInit(): void {
    this.initLang();
    this.spinnerService.isLoading$.subscribe((spinner) => {
      Promise.resolve().then(() => {
        this.isLoading = spinner === SpinnerState.VISIBLE;
      });
    });
    this.isApp = this.gabaritService.isAppMobile();
  }

  private initLang() {
    this.translateService.setDefaultLang(this.langueService.langFR);
    this.translateService.use(this.langueService.getCurrentLanguage());
  }
}
